import "./oauthResponse.component.scss";

import { getTranslation, i18nReactive } from "../../../../app/i18/i18tn";

import { DivWithSpinner } from "@tedivo/tedivo-ui";
import { I18nComponentRegisterer } from "@tedivo/tedivo-i18";
import { IFormAndNode } from "../../../helpers/createScreen";
import goSquared from "../../../../app/tracking/goSquared";
import { routeFns } from "../../../../app/router/routes";
import router from "../../../../app/router";
import { setAppTitle } from "../../../../app/setAppTitle";

export class TVDAuthOauthResponseComponent extends HTMLElement {
  public static observedAttributes = [];

  private i18nCR: I18nComponentRegisterer;
  private divWithSpinner: DivWithSpinner;
  private h1Node: HTMLHeadingElement;
  private didChangePassword = false;
  private prevLoginStatus: boolean | undefined = undefined;

  private currentFormAndNode?: {
    formId: string;
  } & IFormAndNode<IAuthResponseFields>;

  private returnUrl = routeFns.myCloud();

  constructor() {
    super();
    this.i18nCR = new I18nComponentRegisterer(i18nReactive);
    this.divWithSpinner = document.createElement("div-spinner-element");
    this.h1Node = document.createElement("h1");

    setAppTitle(getTranslation("auth:logIn"));
  }

  // /** Replaces the UI */
  // private setCurrentFormAndNode = (fan: typeof this.currentFormAndNode) => {
  //   this.currentFormAndNode = fan;

  //   if (fan?.node) {
  //     this.divWithSpinner.setLoading(false);
  //     removeChildren(this.divWithSpinner);
  //     this.divWithSpinner.appendChild(fan.node);
  //   }
  // };

  connectedCallback() {
    this.appendChild(this.divWithSpinner);
    this.showScreen();

    goSquared.trackPage("OAuth Response");

    const qs = router.getRouteHash();
    console.log("hash", qs);

    router.navigate(routeFns.login(), true);
  }

  private onShowScreen = () => {
    this.showScreen();
  };

  /** Shows/Replaces the log-in screen based on securityModule.isLoggedIn, force = false */
  showScreen = () => {
    setAppTitle(getTranslation("auth:oauthResponse"));
    goSquared.addEvent("OAuth Response - Show page");
  };

  disconnectedCallback() {
    this.i18nCR.disconnect();
  }
}

customElements.define(
  "tvd-oauth-response-component",
  TVDAuthOauthResponseComponent,
);

declare global {
  interface HTMLElementTagNameMap {
    "tvd-oauth-response-component": TVDAuthOauthResponseComponent;
  }
}

interface IAuthResponseFields {
  code: string;
}
